import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ComposedTextField from '../ComposedField/ComposedTextField';
export default function OrganizationName(_ref) {
  let {
    name = 'organization-name',
    label = 'Organization Name',
    autoComplete = 'organization',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, props, {
    name: name,
    label: label,
    autoComplete: autoComplete
  }));
}